import React from 'react'

function PortAttributeInfo (props) {
  if (props.item.value === '') props.item.value = null
  if (props.item.price === '') props.item.price = null

  let children = null

  if (props.showall === true && typeof props.item.children === 'object' && props.item.children.length > 0) {

    children = Object.keys(props.item.children).map(key => <tr key={key}>
      <td>
        {props.item.children[key].label}
      </td>
      <td>
        {props.item.children[key].value}
      </td>
      <td dangerouslySetInnerHTML={{ __html: props.item.children[key].price }}/>
    </tr>)
  }

  return (
    <>
      <tr>
        <td>{props.item.label}</td>
        <td>{props.item.value}</td>
        <td dangerouslySetInnerHTML={{ __html: props.item.price }}/>
      </tr>
      {children}
    </>
  )
}

export default PortAttributeInfo